/** Контент лендинга `/use-cases/webinar-timer` (вёрстка — `UseCasePageLayout`). */

import type { UseCasePageContent } from './useCasePageContent';

export const WEBINAR_TIMER_CONTENT: UseCasePageContent = {
  heroEyebrow: 'ВЕБИНАРЫ И ОНЛАЙН-МЕРОПРИЯТИЯ',
  heroLead:
    'Замена таблицам и отдельным таймерам. Держите вебинар в графике: программа, обратный отсчёт и сообщения спикерам в одном окне браузера — рядом с любой платформой: Zoom, Teams, YouTube.',
  heroNote: 'Бесплатно. Без регистрации, в браузере.',

  scenarios: {
    title: 'Где пригодится',
    lead:
      'preztimer держит тайминг онлайн-формата, когда ведущий, продюсер и спикеры в разных окнах и городах.',
    items: [
      {
        title: 'Панельные дискуссии',
        text: 'Равное время участникам, общий отсчёт видят и ведущий, и продюсер за кадром.',
      },
      {
        title: 'Q&A и интервью',
        text: 'Тайм-бокс на блок вопросов, подсказки спикеру прямо на экране таймера.',
      },
      {
        title: 'Одиночные доклады и питчи',
        text: 'Один экран с отсчётом рядом со слайдами — спикер сам видит, сколько осталось.',
      },
    ],
  },

  share: {
    title: 'Готовьте и ведите вебинар вместе',
    paragraphs: [
      'Спланируйте программу, прорепетируйте и держите тайминг в одном месте — для панели, Q&A, интервью или одиночного доклада.',
      'Поделитесь ссылкой на экран таймера со спикерами, а команде дайте доступ к панели управления — так все видят отсчёт, а управление остаётся у нужных людей. Установка и регистрация не нужны — можно начать с гостевой комнаты.',
    ],
  },

  cloud: {
    title: 'Меняйте тайминг на ходу',
    lead:
      'Перерасход или ускорение — это правка таймера, а не пересчёт формул в таблице.',
    bullets: [
      'правите длительность — расчётные времена пересчитываются и синхронно обновляются на всех устройствах;',
      'кнопки добавляют или убавляют время прямо в эфире;',
      'добавляйте и переставляйте таймеры программы по ходу подготовки.',
    ],
  },

  communication: {
    title: 'Сообщения спикерам без сбоев',
    lead:
      'Подсказки приходят на экран таймера — их не пропустят и не потеряют в чате.',
    bullets: [
      'прямые сообщения рядом с отсчётом: «завершайте», «переходим к вопросам»;',
      'цветовые зоны и мигание в красной зоне перед концом блока;',
      'показывайте или скрывайте сообщение, когда нужно.',
    ],
  },

  modes: {
    title: 'Любое устройство и часовые пояса',
    lead:
      'preztimer работает рядом с любой платформой вебинара — это отдельное окно браузера.',
    bullets: [
      'открывается на ПК, планшете и телефоне без установки;',
      'экран таймера — в отдельном окне или через демонстрацию экрана;',
      'часы показывают местное время устройства — удобно спикерам в разных зонах.',
    ],
  },

  pricing: {
    title: 'Цены',
    lead:
      'Для нечастых вебинаров базовых функций хватит — бесплатно. Профи добавляет больше таймеров, комнат и подключений.',
  },

  crossLink: {
    title: 'Связанный сценарий: презентации и доклады',
    lead:
      'Один ведущий и один экран с отсчётом рядом со слайдами — отдельная страница для докладов и питчей.',
    to: '/use-cases/presentations',
    linkLabel: 'Таймер для презентаций и докладов',
  },

  faqSectionTitle: 'Частые вопросы о таймере для вебинара',
  faqItems: [
    {
      question: 'Можно ли подготовить таймеры вебинара заранее?',
      answer:
        'Да. Создайте таймеры на блоки программы, а нужным задайте старт в конкретное время. К следующему таймеру вы переходите вручную с панели управления, в том числе с телефона.',
    },
    {
      question: 'Виден ли таймер зрителям вебинара?',
      answer:
        'Экран таймера предназначен для ведущего и команды — откройте его в отдельном окне или покажите через демонстрацию экрана. Зрителям в чате preztimer сигналы не рассылает: это делает платформа вебинара.',
    },
    {
      question: 'Можно ли собирать вопросы от зрителей?',
      answer:
        'Сбора вопросов от зрителей в preztimer нет — используйте Q&A вашей платформы вебинара. На экране таймера показывайте короткие подсказки спикеру и цветовые зоны.',
    },
    {
      question: 'Работает ли рядом с Zoom, Teams и YouTube?',
      answer:
        'Да. preztimer работает в браузере рядом с любой платформой. Покажите экран таймера спикерам через демонстрацию экрана или откройте его во втором окне на их устройствах.',
    },
    {
      question: 'Можно ли пользоваться бесплатно?',
      answer:
        'Да. Базовых функций тайминга достаточно для нечастых вебинаров — это бесплатно, до 3 одновременных подключений. Для команды и больших лимитов есть лицензия Профи.',
    },
    {
      question: 'Что с часовыми поясами удалённых спикеров?',
      answer:
        'Режим часов показывает местное время устройства каждого участника. Для общего тайминга используйте обратный отсчёт — он одинаков для всех, кто открыл экран таймера.',
    },
  ],
};
